'use strict';
var EqpPartnersService = /** @class */ (function () {
    /*@ngInject*/
    function EqpPartnersService($http, Util) {
        this._$http = $http;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
    }
    /*@ngInject*/
    EqpPartnersService.prototype.getEqpPartners = function () {
        var request = this._$http({
            method: "get",
            url: "/api/products/eqpBrands"
        });
        return (request.then(function (response) {
            console.log(response);
            if (response.data && response.data.response) {
                return response.data.response;
            }
            // var qualityPartners={
            // 	"response":[
            // 		{
            // 			"gold_partner":"Anabolic Laboratories",
            // 			"img_url":"../../../assets/images/support-for-your-practice/for-quality/badges.png",
            // 			"description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            // 			"products_url_text":"Anabolic Products",
            // 				"products_url":""
            // 		},
            // 		{
            // 			"gold_partner":"Ayush Herbs",
            // 			"img_url":"../../../assets/images/support-for-your-practice/for-quality/badges.png",
            // 			"description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            // 			"products_url_text":"Ayush Herbs Products",
            // 			"products_url":""
            // 		},
            // 		{
            // 			"gold_partner":"Bioclinic Naturals",
            // 			"img_url":"../../../assets/images/support-for-your-practice/for-quality/badges.png",
            // 			"description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            // 			"products_url_text":"Bioclinic Naturals Products",
            // 			"products_url":""
            // 		},
            // 		{
            // 			"gold_partner":"Bio-Tech",
            // 			"img_url":"../../../assets/images/support-for-your-practice/for-quality/badges.png",
            // 			"description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            // 			"products_url_text":"Bio-Tech Products",
            // 			"products_url":""
            // 		},
            // 		{
            // 			"gold_partner":"Designs for Health",
            // 			"img_url":"../../../assets/images/support-for-your-practice/for-quality/badges.png",
            // 			"description":"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
            // 			"products_url_text":"Designs for Health Products",
            // 			"products_url":""
            // 		}
            // 	]
            // };
            ////return qualityPartners.response;
        }, this.handleError));
    };
    return EqpPartnersService;
}());
export default EqpPartnersService;
//# sourceMappingURL=eqp-partners.service.js.map